import { render, staticRenderFns } from "./BillingInfoAlert.vue?vue&type=template&id=e7040a30&scoped=true&"
import script from "./BillingInfoAlert.vue?vue&type=script&lang=ts&"
export * from "./BillingInfoAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7040a30",
  null
  
)

export default component.exports